import { render, staticRenderFns } from "./ActiveFeedback.vue?vue&type=template&id=578339c4"
import script from "./ActiveFeedback.vue?vue&type=script&lang=js"
export * from "./ActiveFeedback.vue?vue&type=script&lang=js"
import style0 from "./ActiveFeedback.vue?vue&type=style&index=0&id=578339c4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports